"use strict";

import picturefill from 'picturefill'
import Loading from './modules/Loading'
import Slider from './modules/Slider'
import OvserberAnimation from './modules/OvserberAnimation'
import Navigation from './modules/Navigation'

/**
 * @export
 * @class Main
 */
export default class Main {
  constructor() {
    this.init()
  }

  init() {
    this.picture()
    new Loading()
    new OvserberAnimation()
    new Slider()
    new Navigation()
  }

   picture() {
     picturefill()
   }
}

window.addEventListener('DOMContentLoaded', () => new Main())